import Vue from "vue";
import {
  Button,
  Select,
  Input,
  Row,
  Col,
  Footer,
  Header,
  Main,
  Menu,
  MenuItem,
  Dialog,
  FormItem,
  Form,
  Loading,
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from "element-ui";
import VueTidio from "vue-tidio";

import("element-ui/lib/theme-chalk/index.css");

import "pannellum/build/pannellum";
import("pannellum/build/pannellum.css");

import App from "./App.vue";
import router from "./routes";
import store from "./store/index";

Vue.use(Button);
Vue.use(Select);
Vue.use(Input);
Vue.use(Row);
Vue.use(Col);
Vue.use(Header);
Vue.use(Main);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Footer);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(VueTidio, {
  appKey: "7ae9d0cubnpksevtdpxha69w8jccuipr",
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
